// Imported for its side effect, and it must be the first import in `main.tsx`:
// ES modules evaluate in import order, and `router` reads the URL the moment it
// is created. See `link-credentials.ts`.
import { stripLinkCredentials } from "./link-credentials";

stripLinkCredentials();
